import 'react-datepicker/dist/react-datepicker.css';
import { Box, FormControl, Input, Select, Textarea, FormLabel, FormHelperText, useColorModeValue } from '@chakra-ui/react';

// Assets
import { formatDate } from 'services/Utils';

const FilterSelect = ({ 
  id, 
  options, 
  label,
  value, 
  onChange, 
  placeholder = '',
  bg,
  ...restProps
}) => {
  const bgColor = useColorModeValue('white !important', '#0A1027 !important');
  const border = useColorModeValue('1px solid #CBE7FF !important', '1px solid #262D47 !important');

  return (
  	<Box mb={restProps.mb ?? '16px'}>
		<Select 
	    	bg={bg ?? bgColor} 
	    	border={border}
	    	_focus={{border}}
	    	h="40px !important" 
	    	id={id} 
	    	name={id} 
	    	w={restProps.w ?? '164px'}
	    	placeholder={placeholder} 
	    	value={value} 
	    	onChange={onChange} 
	    	>
	        { options?.map((option, index) => (
	        	<option key={index} value={option.value}>{option.title}</option>
	        ))}
	    </Select>
    </Box>
  );
};

export default FilterSelect;